var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLongArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 87,
    viewBox: "0 0 22 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000127792 87L1.98232 81.5774L5.68731 86.0053L0.000127792 87ZM16.4749 0.843094C19.6026 10.3066 22.5888 25.5274 21.7249 41.2145C20.8611 56.8988 16.1432 73.1194 3.78604 84.4834L3.10913 83.7474C15.2004 72.6278 19.8703 56.7049 20.7264 41.1595C21.5823 25.6168 18.6205 10.5217 15.5254 1.15691L16.4749 0.843094Z",
    fill: "#999999"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iODciIHZpZXdCb3g9IjAgMCAyMiA4NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMDAwMTI3NzkyIDg3TDEuOTgyMzIgODEuNTc3NEw1LjY4NzMxIDg2LjAwNTNMMC4wMDAxMjc3OTIgODdaTTE2LjQ3NDkgMC44NDMwOTRDMTkuNjAyNiAxMC4zMDY2IDIyLjU4ODggMjUuNTI3NCAyMS43MjQ5IDQxLjIxNDVDMjAuODYxMSA1Ni44OTg4IDE2LjE0MzIgNzMuMTE5NCAzLjc4NjA0IDg0LjQ4MzRMMy4xMDkxMyA4My43NDc0QzE1LjIwMDQgNzIuNjI3OCAxOS44NzAzIDU2LjcwNDkgMjAuNzI2NCA0MS4xNTk1QzIxLjU4MjMgMjUuNjE2OCAxOC42MjA1IDEwLjUyMTcgMTUuNTI1NCAxLjE1NjkxTDE2LjQ3NDkgMC44NDMwOTRaIiBmaWxsPSIjOTk5OTk5Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };